import { 
    IconButton, 
    Menu, 
    MenuButton, 
    MenuList, 
    MenuItem as ChakraMenuItem,
    useColorModeValue,
    HStack,
    Text
} from "@chakra-ui/react";
import { FC } from "react";
import { BsThreeDotsVertical } from 'react-icons/bs';
import { IconType } from 'react-icons';
import React from "react";

interface IFloatMenuCustomProps {
    options: {
        onClick: (data?: any) => void;
        title: string;
        icon?: React.ReactNode;
        titleColor?: string;
    }[];
    iconColor?: string;
    titleColor?: string;
    defaultIcon?: IconType;
    menuPosition?: 'left' | 'right';
}

const FloatMenuCustom: FC<IFloatMenuCustomProps> = ({ 
    options, 
    iconColor = 'inherit',
    titleColor = 'inherit',
    defaultIcon = BsThreeDotsVertical,
    menuPosition = 'left'
}) => {
    const DefaultIcon = defaultIcon;
    const defaultTextColor = useColorModeValue('gray.700', 'gray.200');
    
    return (
        <Menu placement={menuPosition === 'left' ? 'bottom-start' : 'bottom-end'}>
            <MenuButton
                as={IconButton}
                icon={<DefaultIcon />}
                variant="ghost"
                colorScheme="gray"
                color={iconColor === 'inherit' ? defaultTextColor : iconColor}
                size="sm"
                aria-label="Menu options"
            />
            <MenuList>
                {options.map((item, index) => (
                    <ChakraMenuItem 
                        key={index}
                        onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
                            item.onClick(e);
                        }}
                        color={item.titleColor || (titleColor === 'inherit' ? defaultTextColor : titleColor)}
                    >
                        <HStack spacing={2}>
                            {item.icon && <span>{item.icon}</span>}
                            <Text>{item.title}</Text>
                        </HStack>
                    </ChakraMenuItem>
                ))}
            </MenuList>
        </Menu>
    );
};

export { FloatMenuCustom };